import { type Registry as Services } from '@ember/service';

type Features = Services['features'];

export function isV2PageRoute(routeName: string, features: Features): boolean {
  const isTeamPresetsPage =
    features.isTeamPresetsEnabled &&
    (routeName === 'account.team.index' ||
      routeName.startsWith('account.team.person'));

  return (
    routeName.startsWith('monthly.') ||
    routeName.startsWith('clients.') ||
    routeName === 'comp-sets' ||
    routeName.startsWith('connect.') ||
    routeName.startsWith('insights.') ||
    routeName.startsWith('ai-messaging.') ||
    routeName.startsWith('calendar') ||
    routeName.startsWith('direct.') ||
    routeName.startsWith('notifications.') ||
    routeName.startsWith('outbound') ||
    routeName.startsWith('protection') ||
    routeName === 'account.team.roles' ||
    isTeamPresetsPage
  );
}

export function isV2OverlayRoute(
  routeName: string,
  features: Features,
): boolean {
  const isActionPage =
    routeName === 'action' || routeName.startsWith('action.');

  return (
    isV2PageRoute(routeName, features) ||
    (isActionPage && features.isTaskCentreEnabled)
  );
}
